import { initiateGam } from '@client/adManager/initiateGam.js';
import { $config } from '@client/core/atoms/config.js';
import { getInterminglePlacements } from '@client/core/atoms/placements.js';
import { setupTravelEvents } from '@client/core/utils/events/setupTravelEvents.js';
import { events, messageBus } from '@schibsted-nmp/advertising-events';
import {
  debug,
  hasItems,
  PageType,
  Vertical
} from '@schibsted-nmp/advertising-shared';

import {
  initializeFilterCollisionDetection,
  disconnectFilterObserver
} from '../dom/handleAdsOverlap/filterCollisionDetection.js';
import { refreshKeywords } from '../refreshKeywords.js';

let cleanupHandler: (() => void) | null = null;

export function setupEvents() {
  const { pageType, vertical } = $config.get() ?? {};

  if (cleanupHandler) {
    window.removeEventListener('beforeunload', cleanupHandler);
    cleanupHandler = null;
  }

  // Keep this for backward compatibility
  const interminglePlacements = getInterminglePlacements();

  if (hasItems(interminglePlacements)) {
    debug.message`Detected ${interminglePlacements.length} intermingle placement(s)`(
      ...interminglePlacements
    ).info((log) => log());

    messageBus.publish('advertising-podlet', 'podlet-ready', {
      placementsWithIntermingle: interminglePlacements
    });
  } else {
    debug.message('No intermingle placements detected').verbose();
  }

  if (vertical === Vertical.Travel) {
    setupTravelEvents();
  } else if (pageType === PageType.Result) {
    messageBus.subscribe(
      events.SEARCH.channel,
      events.SEARCH.FILTER.topic,
      refreshKeywords.sync
    );

    messageBus.subscribe(
      events.SEARCH.channel,
      events.SEARCH.EXPANDABLE_UPDATE.topic,
      () => {
        // ? EXPANDABLE_UPDATE event is not coming through, we didn't investigate why.
        // Keeping it here in case we want to fix and use it in the future.
        // For now, collision detection is handled via ResizeObserver in initializeFilterCollisionDetection instead.
        // checkMiddleBannerCollisions();
      }
    );

    initializeFilterCollisionDetection();

    cleanupHandler = () => {
      disconnectFilterObserver();
    };

    window.addEventListener('beforeunload', cleanupHandler);
  }

  if (pageType === PageType.Object) {
    messageBus.subscribe(
      events.ITEM_PAGE.channel,
      events.ITEM_PAGE.INCAROUSEL_IMAGE_UPDATE.topic,
      initiateGam.handleInCarouselImageUpdate
    );
  }
}
